import { Component, Event, EventEmitter, State, Prop, h } from '@stencil/core';

@Component({
  tag: 'lab-ds-text-area',
  styleUrl: 'lab-ds-text-area.css',
  shadow: true,
})
export class LabDsTextArea {
  @Prop() value!: string;

  @State() valueState: string = this.value;

  @Prop() maxLength: number = 100;

  @Prop() minLength: number = 0;

  @Prop() rows: number = 5;

  @Prop() cols: number = 30;

  @Prop() titleInput: string = '';

  @Prop() label: string = '';

  @Prop() disabled: boolean = false;

  @Prop() helperText: string = '';

  @Prop() state: 'error' | 'success' | 'default' = 'default';

  @Event() changeInput: EventEmitter<string>;

  handleChange(event) {
    this.changeInput.emit(event.target.value);
    this.valueState = event.target.value;
  }

  render() {
    const iconHelper = {
      error: { icon: 'error' },
      success: { icon: 'check_circle' },
      default: { icon: '' },
    };

    return (
      <div class={`v4-input ${this.state} ${this.disabled && 'disabled'}`}>
        <div class="title-count">
          <span class="title-text">{this.titleInput}</span>
          <span class="title-counter">
            {this.valueState ? this.valueState?.length : '0'}/{this.maxLength}
          </span>
        </div>
        <div class="input-helper">
          <div class="input-icon">
            <textarea
              rows={this.rows}
              cols={this.cols}
              disabled={this.disabled}
              placeholder={this.label}
              class="input-field"
              maxLength={this.maxLength}
              minLength={this.minLength}
              value={this.value}
              onInput={event => this.handleChange(event)}
            />
            {iconHelper[this.state].icon && <lab-ds-icon-not-selectable class="icon right" size="small" icon={iconHelper[this.state].icon} />}
          </div>
          {this.helperText && (
            <span class="helper-text">
              {iconHelper[this.state].icon && <lab-ds-icon-not-selectable class="icon" size="x-small" icon={iconHelper[this.state].icon} />}
              {this.helperText}
            </span>
          )}
        </div>
      </div>
    );
  }
}
